/* Imports needed for all question form subclasses. */
import * as React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import {
    mapStateToQuestionFormBaseProps,
    mapDispatchToQuestionFormBaseProps
} from '../../QuestionFormBase';

import {
    QuestionFormWithOptionsBase,
    QuestionFormWithOptionsBaseProps,
    QuestionFormWithOptionsBaseStates
} from '../QuestionFormWithOptionsBase';
import { OPTION_SIZE, PROJECT_STATUS, QTYPES } from '@nexxt/common/types';
import NotifyHOC from '../../../../../../HOC/Notifications';

/* Components used in this question form. */
import BuilderHeader from '../../../common/builderHeader';
import { OPTION_TYPES } from '@nexxt/common/types';
import Options from '../../../common/Options';

interface Props extends QuestionFormWithOptionsBaseProps {
    // nothing special... yet!
}

interface States extends QuestionFormWithOptionsBaseStates {
    // nothing special... yet!
}
class VirtualQuestion extends QuestionFormWithOptionsBase<Props, States> {
    constructor(p: QuestionFormWithOptionsBaseProps) {
        super(p, QTYPES.VIRTUAL);
        const question = {
            ...this.state.question,
            selectedOptionType: OPTION_TYPES.CONDITION,
            showNotApplicableOption: true,
            optionSettings: {
                ...this.state.question.optionSettings,
                numColumns: 1,
                size: OPTION_SIZE.LARGE
            }
        };
        this.state = {
            ...this.state,
            showCardSettings: true,
            question
        };
    }

    render() {
        const { question, showCardSettings, isSettingBoxLayoutOpen } =
            this.state;
        const questionError =
            (this.state.showError && this.state.questionError) || {};
        return (
            <div>
                <div className="project-add--question-builder">
                    <BuilderHeader
                        toggleSettingBoxLayout={this.toggleSettingBoxLayout}
                        isSettingBoxLayoutOpen={isSettingBoxLayoutOpen}
                        showQuestionSetting={false}
                        showAlert={!this.props.editEnabled}
                        alertMessages={this.getWarningMessage()}
                        question={question}
                        setValue={this.setQuestion}
                        disabled={!this.props.editEnabled}
                        errorObject={this.state.questionError}
                    />
                    <div className="builder-body">
                        {this.renderErrorNotes()}

                        <div className="option-settings-block">
                            <div className="form-group-header display-flex">
                                Custom Variables
                                <span>
                                    Reference custom variables via text
                                    referencing, to show responsive wording, or
                                    in audience page, to set quotas
                                </span>
                            </div>
                            {/** Show Option Add Button as well as Pipe Option Button  */}
                            {/** Show Option Cards according to option type */}
                            {/* {showCardSettings && this.renderOptionCard()}{' '}
                            {this.renderOptionAddButton()}{' '}
                            {(questionError &&
                                (questionError.options || {})
                                    .isEmptyOptions && (
                                    <div
                                        className={`form-group ${
                                            questionError ? 'error' : ''
                                        }`}
                                    >
                                        <label className="form-group__label form-group__label--block">
                                            {
                                                questionError.options
                                                    .isEmptyOptions
                                            }
                                        </label>
                                    </div>
                                )) ||
                                null} */}
                            <Options
                                name="variable"
                                question={question}
                                questionSummaries={this.props.questionSummaries}
                                setQuestionAsQuestion={
                                    this.setQuestionAsQuestion
                                }
                                setQuestion={this.setQuestion}
                                setQuestionWithLanguage={
                                    this.setQuestionWithLanguage
                                }
                                setMultimediaText={
                                    this.NEW_setQuestionTextTranslation
                                }
                                setOtherOptionWithLanguage={
                                    this.setOtherOptionWithLanguage
                                }
                                handleOptions={this.handleOptions}
                                languages={this.props.currentProject.languages}
                                countries={this.props.currentProject.countries}
                                error={this.state.questionError || {}}
                                showError={this.state.showError}
                                disabled={!this.props.editEnabled}
                                projectHealthOptionIds={this.getProjectHealthOptionIds()}
                                settings={{
                                    hideHeader: true,
                                    hideFooter: true,
                                    disableMenu: true,
                                    disableDnd: true,
                                    hideNotApplicable: true,
                                    hideEditDesign: true,
                                    hideAdvancedFooter: true
                                }}
                                isLive={
                                    this.props.currentProject.status ==
                                    PROJECT_STATUS.LIVE
                                }
                                previousPackageQuestion={
                                    (this.props.currentProject
                                        .previousPackage &&
                                        this.props.currentProject.previousPackage.questions.find(
                                            (q) => q.id == question.id
                                        )) ||
                                    null
                                }
                            />
                        </div>
                    </div>
                    {/*end of builder body*/}
                </div>
            </div>
        );
    }
}

export default withRouter(
    NotifyHOC(
        connect(
            mapStateToQuestionFormBaseProps,
            mapDispatchToQuestionFormBaseProps
        )(VirtualQuestion)
    )
);
